import { loadPref, savePref } from './prefs';

// The theme (dark mode, nav style, Harbor accent and each style's last pick)
// saved for the signed-in user as the 'theme' preference, so it follows them
// to any browser. The browser keeps its own copy under the keys below, read at
// start so the page shows the theme at once; the server's copy wins once the
// user is known. While an admin is impersonating someone nothing is saved.

const KEYS = {
  dark: 'harbor-theme',
  nav: 'harbor-nav-style',
  accent: 'harbor-accent',
  yacht: 'harbor-accent-yacht',
  wood: 'harbor-accent-wood',
};
export const THEME_LOADED = 'harbor-theme-loaded';   // window event: the browser copy was replaced

let uid = null;
let applying = false;

function readLocal() {
  const out = {};
  try {
    Object.entries(KEYS).forEach(([k, key]) => { const v = localStorage.getItem(key); if (v) out[k] = v; });
  } catch { /* private window */ }
  return out;
}

// After any theme change (the browser copy already written).
export function saveTheme() {
  if (!uid || applying) return;
  const value = readLocal();
  if (Object.keys(value).length) savePref(uid, 'theme', value);
}

// Once signed in: the saved theme replaces this browser's, or, when none is
// saved yet, this browser's is saved for them.
export async function loadTheme(userId) {
  try { if (localStorage.getItem('impersonateUserId')) return; } catch { return; }
  uid = userId;
  const saved = await loadPref(userId, 'theme');
  if (!saved || typeof saved !== 'object') { saveTheme(); return; }
  const local = readLocal();
  if (Object.keys(KEYS).every((k) => (saved[k] || null) === (local[k] || null))) return;
  try {
    Object.entries(KEYS).forEach(([k, key]) => {
      if (saved[k]) localStorage.setItem(key, saved[k]); else localStorage.removeItem(key);
    });
  } catch { return; }
  applying = true;
  try { window.dispatchEvent(new Event(THEME_LOADED)); } finally { applying = false; }
}
